module.exports = __webpack_public_path__ + "img/2024122602.b9a5270e.png";